<template>
    <div class="space-y-6">
        <div v-for="(problem) in data" 
             v-bind:key="problem.id" 
             class="space-y-4">
            <!-- Coder Comment -->
            <div class="space-y-2">
                <div class="flex items-center space-x-2 text-sm">
                    <span class="font-medium text-gray-900">Coder</span>
                    <span class="text-gray-500">&middot;</span>
                    <span class="text-gray-500" v-text="problem.created_ago"></span>
                </div>
                <div class="p-4 bg-amber-50 rounded-lg border border-amber-100 text-gray-700">
                    <p class="whitespace-pre-wrap" v-text="problem.comment"></p>
                </div>
            </div>

            <!-- Resolution Comment -->
            <div v-if="problem.resolved_comment" class="space-y-2 ml-6">
                <div class="flex items-center space-x-2 text-sm">
                    <span class="font-medium text-gray-900">Resolution</span>
                    <span class="text-gray-500">&middot;</span>
                    <span class="text-gray-500" v-text="problem.resolved_ago"></span>
                </div>
                <div class="p-4 bg-blue-50 rounded-lg border border-blue-100 text-gray-700">
                    <p class="whitespace-pre-wrap" v-text="problem.resolved_comment"></p>
                </div>
            </div>
        </div>

        <!-- New Resolution Input -->
        <div class="space-y-2">
            <label class="block text-sm font-medium text-gray-700">Resolution</label>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['problems'],
        data() {
            return {
                data: this.problems,
            }
        }, 
        computed: {
            lastProblem: function() {
                return this.problems.slice(-1)[0];
            }
        },
        methods: {
            addComment() {
                this.patch('/problems/'+this.lastProblem.id, {'resolved_comment': this.resolution})
                    .then(({data}) => {
                        this.data.slice(-1)[0] = data;
                    })
            }
        }
    }
</script>